// @flow
import * as React from 'react';
import Popover from 'react-popover';
import ChevronDownCircleIcon from '@atlaskit/icon/glyph/chevron-down-circle';

import {
  PopupBody,
  Trigger,
} from './styled';


type Props = {
  /**
   * Contents to render in popup
   */
  children: React.Node,
  /**
   * Custom trigger
   */
  trigger: React.Node,
  triggerSize?: string | number,
  preferPlace?: string | null,
  place: string,
  isOpen: boolean,
  handleOuterAction: { (): void },
  setPopupVisible: { (): void },
};

const Popup = ({
  children,
  triggerSize,
  preferPlace,
  place,
  trigger,
  isOpen,
  setPopupVisible,
  handleOuterAction,
  triggerWidth,
}: Props) => (
  <Popover
    body={(
      <PopupBody>
        {children}
      </PopupBody>
    )}
    isOpen={isOpen}
    preferPlace={preferPlace}
    place={place}
    tipSize={0.01}
    onOuterAction={handleOuterAction}
    appendTarget={window.document.body}
  >
    <Trigger
      width={triggerWidth}
      onClick={setPopupVisible}
    >
      {trigger || (
        <ChevronDownCircleIcon
          label={isOpen ? 'close' : 'open'}
          style={{
            transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
            cursor: 'pointer',
          }}
          size={triggerSize}
        />
      )}
    </Trigger>
  </Popover>
);

Popup.defaultProps = {
  triggerSize: 'medium',
  preferPlace: null,
};

export default Popup;
